<template>
  <EIcon
    icon="highlight-star"
    size="s"
    class="personal-counter-indicator__icon"
    :class="{ 'personal-counter-indicator__icon--delayed': withDelay }"
  />
</template>

<script>
import EIcon from '~~/common/vue/components/icon';

export default {
  name: 'EPersonalCounterIndicator',
  components: {
    EIcon,
  },
  props: {
    withDelay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-counter-indicator__icon {
  animation: fadeIn $timing-m;
  animation-fill-mode: forwards;
  color: $c-red-30;
  z-index: $z-index-l;
  position: absolute;
  right: 3px;
  top: 3px;
  opacity: 0;

  @include desktop {
    left: 33px;
    top: 1px;
  }
}

.personal-counter-indicator__icon--delayed {
  animation-delay: $timing-1l;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
